import debounce from 'lodash.debounce';

// preact
import { h, render } from 'preact';

// components
import SearchProducts from './search-products';
import CustomizerStyleModal from '../customizer-style-modal/modal';

// hooks
import useCustomizerStyleModal from '../../hooks/useCustomizerStyleModal';

export default function initializeMenu(element, data) {
  const toggleMenu = element.querySelector('[data-menu-toggle]');
  const mainMenuContainer = element.querySelector('[data-main-container]');
  const secondMenuContainer = element.querySelector('[data-second-container]');
  const secondMenuClose = element.querySelector('[data-close-sub]');
  const mainMenuClose = element.querySelector('[data-close-menu]');
  const subMenuToggles = element.querySelectorAll('[data-sub-target]');
  const bothMenuClose = element.querySelector('[data-close-menu-sub]');
  const backface = element.querySelector('[data-backface]');
  const headerEl = element.querySelector('[data-header]');
  const searchForm = element.querySelector('[data-search]');
  const searchProducts = element.querySelector('[data-search-products]');
  const searchInput = element.querySelector('[data-search] input');
  const searchPanel = element.querySelector('[data-search-panel]');
  const clearSearchButton = element.querySelector('[data-clear-search]');

  const GlobalCustomizerStyleModal = () => {
    const {
      isCustomizerStyleModalOpen,
      isKidsGraphic,
      isHoodieGraphic,
      isTankGraphic,
      customizerBackgroundImgUrl,
      closeCustomizerStyleModal,
    } = useCustomizerStyleModal();

    return (
      <CustomizerStyleModal
        isOpen={isCustomizerStyleModalOpen}
        onClose={closeCustomizerStyleModal}
        isKidsGraphic={isKidsGraphic}
        isHoodieGraphic={isHoodieGraphic}
        isTankGraphic={isTankGraphic}
        customizerBackgroundImgUrl={customizerBackgroundImgUrl}
        customizerStyles={data.customizerStyles}
      />
    );
  };

  const initSearchProducts = () => {
    render(<SearchProducts {...data} />, searchProducts);
  };

  const init = () => {
    const debouncedResizeHandler = debounce(onResizeHandler, 500);
    window.addEventListener('resize', debouncedResizeHandler);
    onResizeHandler();

    searchInput.addEventListener('click', handleSearchPanel);
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        handleSearchPanel();
      }
    });
    searchInput.addEventListener('input', (e) => handleSearchResults(e));
    searchForm.addEventListener('submit', (e) => handleFormSubmit(e));
    clearSearchButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearch();
    });

    document.addEventListener('click', (e) => handleHeaderClick(e));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSearch(e);
      }
    });

    if (data.template !== 'product') {
      let lastScroll = 0;
      let isScrolled = false;
      window.addEventListener('scroll', () => {
        const headerSection = document.querySelector('.shopify-section-header');
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const scrollDirection = currentScroll < lastScroll;
        const shouldToggle = isScrolled && scrollDirection;
        isScrolled = currentScroll > 100;
        headerSection?.classList.toggle('sticky', shouldToggle);
        headerSection?.classList.toggle('animate-slideDown', shouldToggle);
        lastScroll = currentScroll;
      });
    }

    toggleMenu.addEventListener('click', () => {
      backface.classList.add('!block');
      mainMenuContainer.classList.add('left-slide');
      document.body.classList.add('scroll-lock');
    });

    subMenuToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const searchedMenu = toggle.dataset.subTarget;
        secondMenuContainer.classList.add('left-slide');
        element.querySelector(`[data-sub-menu="${searchedMenu}"]`).classList.add('show-flex');
      });
    });

    secondMenuClose.addEventListener('click', (e) => {
      e.preventDefault();
      element.querySelector('.show-flex[data-sub-menu]').classList.remove('show-flex');
      secondMenuContainer.classList.remove('left-slide');
    });

    mainMenuClose.addEventListener('click', (e) => {
      e.preventDefault();
      mainMenuContainer.classList.remove('left-slide');
      backface.classList.remove('!block');
      document.body.classList.remove('scroll-lock');
    });

    bothMenuClose.addEventListener('click', (e) => {
      e.preventDefault();
      element.querySelector('.show-flex[data-sub-menu]').classList.remove('show-flex');
      secondMenuContainer.classList.remove('left-slide');
      mainMenuContainer.classList.remove('left-slide');
      backface.classList.remove('!block');
      document.body.classList.remove('scroll-lock');
    });

    backface.addEventListener('click', () => {
      element.querySelector('.show-flex[data-sub-menu]')?.classList.remove('show-flex');
      secondMenuContainer.classList.remove('left-slide');
      mainMenuContainer.classList.remove('left-slide');
      backface.classList.remove('!block');
      document.body.classList.remove('scroll-lock');
    });
  };

  const handleSearchPanel = () => {
    searchPanel.classList.add('active');
    clearSearchButton.classList.remove('hidden');
    document.body.classList.add('scroll-lock--fixed');
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    window.location.href = `${window.location.origin}/search?q=${searchInput.value}`;
  };

  const closeSearch = () => {
    searchPanel.classList.remove('active');
    searchPanel.classList.remove('no-results');
    document.body.classList.remove('scroll-lock--fixed');
    searchInput.value = '';
    clearSearchButton.classList.add('hidden');
  };

  const handleHeaderClick = (e) => {
    if (
      (!e.target.closest('[data-search]') && !e.target.closest('[data-search-panel]')) ||
      e.target.hasAttribute('data-overlay')
    ) {
      closeSearch();
    }
  };

  const handleSearchResults = (e) => {
    searchPanel.classList.remove('active');
    searchPanel.classList.add('no-results');
    document.body.classList.add('scroll-lock--fixed');
    clearSearchButton.classList.remove('hidden');
    const noResElement = element.querySelector('#no-res');
    if (noResElement) {
      noResElement.textContent = e.target.value;
    }
  };

  const onResizeHandler = () => {
    const viewportOffset = headerEl.getBoundingClientRect();
    document.documentElement.style.setProperty(
      '--header-spacer',
      `${headerEl.offsetHeight + viewportOffset.top || 0}px`,
    );
  };

  init();
  initSearchProducts();

  render(<GlobalCustomizerStyleModal />, element);
}
